import { CustomAlert } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export const AlreadyOnTerminalAlert: FC = () => {
  const { t } = useTranslate()
  return (
    <CustomAlert
      message={t(
        'containerIsAlreadyOnTerminalContactControlRoom',
        'Container is already on terminal, contact control room',
      )}
      severity='warning'
    />
  )
}
